'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = require('vue');

exports.default = Vue.component('input-text', {
    props: ['value', 'label', 'type', 'showPlainText'],
    data: function data() {
        return {
            plainTextEnabled: false,
            inputIdCache: ''
        };
    },
    computed: {
        inputId: function inputId() {
            if (!this.inputIdCache) {
                this.inputIdCache = 'inp_' + Math.floor(Math.random() * 1e17).toString(36);
            }

            return this.inputIdCache;
        },

        currentValue: {
            get: function getCurrentValue() {
                return this.value;
            },
            set: function setCurrentValue(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        updateValue: function updateValue(newValue) {
            this.$emit('input', newValue);
        },
        isEdgeBrowser: function isEdgeBrowser() {
            return navigator.appVersion.indexOf('Edge') > -1;
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputText"]
window._kiwi_exports.components.utils.InputText = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/InputText.vue
// module id = vM24
// module chunks = 1